import { useState, useEffect, useCallback } from 'react';
import { useAuthFetch } from './useAuthFetch';

export interface WorkspaceLoadStatus {
  plan: string;
  currentTokens: number;
  capacity: number;
  used: number;
  percentage: number;
  refillRate: number;
  status: 'ok' | 'warning' | 'empty';
  overageEnabled: boolean;
  appBreakdown: { appId: string; cu: number; percentage: number }[];
}

export interface AICreditStatus {
  plan: string;
  creditsUsed: number;
  creditsLimit: number;
  creditsRemaining: number;
  percentage: number;
  overageEnabled: boolean;
}

/**
 * useWorkspaceLoad — simplified for v5 plan (storage-only meter)
 * Returns null for both load and aiCredits since we no longer have CU metering.
 * The sidebar profile popup uses this — returning null hides the meters.
 */
export function useWorkspaceLoad(pollIntervalMs = 30000) {
  const [load] = useState<WorkspaceLoadStatus | null>(null);
  const [aiCredits] = useState<AICreditStatus | null>(null);
  const [loading] = useState(false);

  const refetch = useCallback(async () => {
    // No-op — CU metering and AI credits are discontinued in v5
  }, []);

  return { load, aiCredits, loading, refetch };
}
